var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-header"},[_c('div',{staticClass:"d-flex"},[_c('h4',{staticClass:"text-h4"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"flex-grow-1"}),_vm._t("default")],2),(_vm.divider)?_c('v-divider'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }